import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository, ITokenService, IStorageService } from '../../../domain/ports';
import type { TwoFactorVerification } from '../../dto/dtos';
import { User } from '../../../domain/entities';

export interface Verify2FAOutput {
  user: User;
}

export class Verify2FAUseCase implements IUseCase<TwoFactorVerification, Verify2FAOutput> {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly tokenService: ITokenService,
    private readonly storageService: IStorageService,
  ) {}

  async execute(input: TwoFactorVerification): Promise<Verify2FAOutput> {
    const response = await this.authRepository.verify2FA(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Code 2FA invalide');
    }

    const result = response.data;

    this.tokenService.setAccessToken(result.tokens.accessToken);

    const user = User.fromLoginResult({
      ...result.utilisateur,
      role: result.utilisateur.role,
    });

    this.storageService.setUser(user.toProfile());

    return { user };
  }
}
